import http from '@/http';

export default class SalaService {

	getDistribuicaoByEstagio(selecaoEstagioId) {			
		return http.get(`sala/selecao-estagio/${selecaoEstagioId}`).then(res => res.data);
    }

	

}
